import { render, staticRenderFns } from "./RegisterOnlineMycourseVideoCopy.vue?vue&type=template&id=2b8e8abb&"
import script from "./RegisterOnlineMycourseVideoCopy.vue?vue&type=script&lang=js&"
export * from "./RegisterOnlineMycourseVideoCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports